import React from 'react';
import './TimeAgo.css';

/**
 * TimeAgo Component
 * Displays relative time (e.g., "2h ago") with a tooltip showing the exact date/time
 */
const TimeAgo = ({ date, className = '' }) => {
    if (!date) return null;

    const formatTimeAgo = (dateString) => {
        const now = new Date();
        const dateObj = new Date(dateString);
        const seconds = Math.floor((now - dateObj) / 1000);

        if (seconds < 60) return 'just now';
        if (seconds < 3600) return `${Math.floor(seconds / 60)}m ago`;
        if (seconds < 86400) return `${Math.floor(seconds / 3600)}h ago`;
        if (seconds < 604800) return `${Math.floor(seconds / 86400)}d ago`;
        if (seconds < 2592000) return `${Math.floor(seconds / 604800)}w ago`;

        // For dates older than a month, show the actual date
        return formatFullDate(dateString);
    };

    const formatFullDate = (dateString) => {
        return new Date(dateString).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    const relativeTime = formatTimeAgo(date);
    const fullDate = formatFullDate(date);

    return (
        <span
            className={`time-ago ${className}`}
            title={fullDate}
            data-tooltip={fullDate}
        >
            {relativeTime}
        </span>
    );
};

export default TimeAgo;
